import {
    SEA_SURFACE_TEMPERATURE_LINE,
    SeaSurfaceTemperatureChart,
} from '@/components/spotter/historicalDataTab/SeaSurfaceTemperatureSection';
import { AlertTriggerReferenceChartProps } from '@/components/spotter/notificationTab/AlertReferenceChart';
import { useAlertsFromForm } from '@/components/spotter/notificationTab/useAlertsFromForm';
import { useSpotterContext } from '@/context/SpotterContext';

const LINES = [SEA_SURFACE_TEMPERATURE_LINE];

export const SeaSurfaceTemperatureAlertReferenceChart = ({ enabled = false }: AlertTriggerReferenceChartProps) => {
    const { spotterId } = useSpotterContext();
    const alerts = useAlertsFromForm();

    if (!spotterId) {
        return;
    }

    return (
        <SeaSurfaceTemperatureChart
            chartTitle={'Sea surface temperature alert'}
            spotterId={spotterId}
            queryEnabled={enabled}
            showAlertLines={true}
            scaleToFitAlerts={true}
            lines={LINES}
            alertLines={alerts}
        />
    );
};
